module.exports = __webpack_public_path__ + "img/hailan.f086550e.png";